import {inject, Service} from '@angular/core'
import {MatSnackBar} from '@angular/material/snack-bar'
import {LatestInterest} from '@sparbanken-syd/kalpylator'
import {filter} from 'rxjs/operators'
import {TermsTexts} from '../model/terms-texts'

import {InterestService} from '../services/interest.service'

/**
 * These are needed here and there...
 */

@Service()
export class InterestResolver {
  private readonly interestService = inject(InterestService)
  private readonly snackBar = inject(MatSnackBar)

  public resolve(): void {
    this.interestService.getLatestInterest()
      .pipe(
        filter((latestInterest: LatestInterest) => {
          if (latestInterest === null) {
            /**
             * Error handling, if the latestValidInterest can't be collected from backend.
             */
            this.snackBar.open('Ett fel har inträffat. Den senaste räntan kunde inte hämtas.', 'OKEJ',
              {
                horizontalPosition: 'center',
                verticalPosition: 'top'
              })
          }
          return latestInterest !== null
        })
      )
      .subscribe(
        (i: LatestInterest) => {
          TermsTexts.setLatestInterest(i)
        }
      )
  }
}
